import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { Toaster, toast } from "sonner";
import { Link } from "react-router-dom";
import { Button, Divider, Inputbox, Logo } from "../components";
import { signIn } from "../app/features/auth/authSlice";
import { frontUrl } from '../constants/base_urls'
const LoginPage = () => {
  const { given_name, email, picture } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (given_name && email && picture) {
      navigate("/");
    }
  }, [given_name, email, picture]);

  const handleLoginSuccess = async (credentials) => {
    dispatch(signIn(credentials.credential));
  };

  return (
    <div className="flex w-full  h-[100vh]">
      <div className="hidden md:flex flex-col gap-y-4 w-1/3 min-h-screen bg-black items-center justify-center">
        <Logo type="signin" />
        <span className="text-xl font-semibold text-white">Welcome, back!</span>
      </div>

      <div className="flex w-full md:w-2/3 h-full bg-white dark:bg-gradient-to-b md:dark:bg-gradient-to-r from-black via-[#071b3e] to-black items-center px-10 md:px-20 lg:px-40">
        <div className="h-full flex flex-col items-center justify-center  py-12 px-4 sm:px-6 lg:px-8">
          <div className="block mb-10 md:hidden">
            <Logo />
          </div>
          <div className="max-w-md w-full space-y-8">
            <div>
              <h2 className="mt-6 text-center text-xl md:text-2xl text-gray-900 dark:text-white">
                Sign in to your account
              </h2>
            </div>

            <GoogleLogin
              onSuccess={handleLoginSuccess}
              onError={() => {
                console.log("Login Failed");
              }}
              login_uri={frontUrl}
              redirect_uri={`http://${frontUrl}/api/auth/callback/google`}
              cancel_on_tap_outside={true}
              useOneTap={true}
              size="large"
              theme="filled_black"
              text="continue_with"
              shape="pill"
              className="w-full bg-red-950"
              width="100"
            />
          </div>

        </div>
      </div>

      <Toaster richColors />
    </div>
  );
};

export default LoginPage;
